<template>
  <div class="h5-problem-details-page">
    <div class="problem-details-title">
      <span>{{ problemData.title }}</span>
    </div>
    <div class="problem-details-content">
      <span>
        　{{ problemData.content }}
      </span>
    </div>
  </div>
</template>
<script>
import { problempost } from "@/utils/api";
export default {
  data() {
    return {
      problemId: "",
      token: "",
      problemData:{}
    };
  },
  mounted() {
    this.problemId = this.$route.query.id;
    this.token = this.$route.query.token;
    this.getProblemList();
  },
  methods: {
    getProblemList() {
      let url = "/system/app/helpCenter/findHelpCenterById";
      let params = {};
      let header = {
        Authorization: "Bearer " + this.token,
      };
      let data = {
        id: this.problemId,
      };
      problempost(url, params, header, data).then((res) => {
        if (res.code == 200) {
          this.problemData = res.result
        } else {
        }
      });
    },
  },
};
</script>
<style lang="scss">
.h5-problem-details-page {
  height: 100%;
  background-color: #ffffff;
  padding: 0 24px;
  .problem-details-title {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    padding: 40px 24px;
    border-bottom: 1px solid #aaaaaa;
  }
  .problem-details-content {
    font-size: 16px;
    color: #333333;
    padding: 30px 0;
  }
}
</style>